import { Button, Dialog, Notice } from '@/shared/ui'

type Props = {
  isOpen: boolean
  onOpenChange: (open?: boolean) => void
}

export const GuestPayDeadlineDialog = ({ isOpen, onOpenChange }: Props) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>결제 마감 시한 안내</Dialog.Title>
          <Dialog.Description className="sr-only">
            결제 마감 시한 안내
          </Dialog.Description>
        </Dialog.Header>
        <div className="space-y-6">
          <Notice.Title hasIcon={false} className="typo-body1 mb-2 text-black">
            1. 결제 마감 시한이 지나면 어떻게 되나요?
          </Notice.Title>
          <Notice.List className="typo-label1 text-gray-600">
            <Notice.Item>
              마감 시한이 지나면 계약은 자동 취소됩니다.
              <br />
              게스트가 마감 시한을 놓친 경우, 다시 계약을 요청할 수<br />
              있도록 안내해 주세요.
            </Notice.Item>
          </Notice.List>
          <Notice.Title
            hasIcon={false}
            className="typo-body1 mb-2 flex text-black"
          >
            <span>2.&nbsp;</span>
            <span>
              게스트의 결제를 기다리는 동안 다른 계약 요청을
              <br />
              받아도 되나요?
            </span>
          </Notice.Title>
          <Notice.List className="typo-label1 text-gray-600">
            <Notice.Item>
              네, 다른 계약 요청도 받으실 수 있어요.
              <br />
              여러 건의 계약을 승인하신 경우, 먼저 결제된 계약이 우선
              <br />
              확정되며, 나머지 계약은 자동으로 취소됩니다.
            </Notice.Item>
          </Notice.List>
        </div>
        <Dialog.Footer className="flex-row">
          <Dialog.Close asChild>
            <Button size="large" color="secondary" fullWidth>
              닫기
            </Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  )
}
